<script setup lang="ts">
import type { Housing } from '~/models/Housing';

const props = defineProps<{
  housing: Housing;
}>();

const isDesktop = useIsDesktop();
const housingImage = computed(() => !isDesktop ? props.housing.previewImage.urlPaths.small : props.housing.previewImage.urlPaths.medium);
</script>

<template>
  <section class="tw-housing-card-wrapper">
<div class="housing-card">
    <div class="--trade-type">
      <tw-trade-variant-badge variant="ring" :auto-hide="false" />
    </div>
    <img class="--image" :alt="housing.title" :src="housingImage" loading="lazy" />
  <div class="--footer">
    <tw-housing-summary :housing="housing" :concise="true" />
    <address class="housing-info-card-header-address">
      {{ addressFromHousing(housing) }}
    </address>
  </div>
</div>
  </section>
</template>

<style scoped lang="scss">
@import '@/assets/styles/tw-variables.scss';
@import '@/assets/styles/tw-mixins.scss';

.tw-housing-card-wrapper {
  .housing-card {
    border: 1px solid $lightGray;
    box-shadow: 0 0.25em 0.5em rgb(0 0 0 / 25%);
    padding: 0;
    position: relative;

    .--image {
      width: 100%;
      aspect-ratio: 4 / 3;
    }

    .--trade-type {
      position: absolute;
      top: 10px;
      left: -1px;
      font-size: 0.9em;
      z-index: 5;
    }

    .tw-badge {
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }

    .--footer {
      padding: 1rem;
      :first-child {
        font-weight: bold;
      }
      address {
        font-style: normal;
      }
    }
  }
}


</style>
